import { differenceInYears } from "date-fns";
//#region src/Age/constants.ts
var ADULT_MINIMUM_AGE = 18;
var INDEPENDENT_MINOR_MINIMUM_AGE = 13;
//#endregion
//#region src/Age/utils.ts
function calculateAge(birthday) {
	return differenceInYears(/* @__PURE__ */ new Date(), birthday);
}
function hasMinimumAge(birthday, minimumAgeInYears) {
	return calculateAge(birthday) >= minimumAgeInYears;
}
function isAdult(birthday) {
	return hasMinimumAge(birthday, 18);
}
//#endregion
export { INDEPENDENT_MINOR_MINIMUM_AGE as a, ADULT_MINIMUM_AGE as i, hasMinimumAge as n, isAdult as r, calculateAge as t };

//# sourceMappingURL=Age-Bqrd3jby.js.map